import React, { useRef } from "react";
import { CXContext } from "./cxContext";
import * as dc from "dc";
import * as d3 from 'd3';
import { rhythm } from "../utils/typography.js";
import { css } from "glamor";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import refresh from "./refresh_icon.png"


let metric = "# of Entries";

const commasFormatter = (num) => {
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)//d3.format(",.0f");
}

const Options = props => {
  const selection = useRef(null);

  const options = ["# of Entries", "Total # of Words", "Average # of Words", "# of Assignments"];//"Total # of Activities", "Average # of Activities"
  //this.handleChange = this.handleChange.bind(this);
  const listOptions = options.map((option, i) =>
    <option key= {i} value={option} >{option}</option>
  );
  const style = css({
    marginRight: rhythm(0.2),
    marginTop: rhythm(0.1),
    padding: rhythm(0.1),
    display: "inline",
    cursor:'pointer',
    float:'right',
    fontSize: '11px',
    maxWidth: '140px',
    borderColor: '#cccc'
  });

  const title = props.title;

  const updateChart = (metric) => {
    if(props.chart) {
      selection.current.value = metric;
      //console.log("select "+selection.current.value)
      const val = props.chart.valueAccessor(function(p) {
        //console.log('metric '+metric);
        if( metric == "# of Entries") return p.value.count;
        else if( metric == "Total # of Words") return p.value.totalWords;
        else if(metric == "Average # of Words") return p.value.avgWords;
        // else if(metric == "Total Vocabulary") return p.value.totalVocabulary;
        // else if(metric == "Average Vocabulary") return p.value.avgVocabulary;
        else if(metric == "# of Assignments") return p.value.id_count;
        else if(metric == "# of Students") return p.value.student_count;
        // else if(metric == 'Total Conversation Time') return p.value.tot_conversation_time;
        // else if(metric == 'Average Conversation Time') return p.value.avg_conversation_time;
      });
      if(props.chartType != 'rowchart'){
        props.chart.yAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(6)
        // if( metric != '# of Conversations' ){
        //   props.chart.yAxis().tickFormat(function(d) { return commasFormatter(d) + ' s'; }).ticks(6)
        // } else props.chart.yAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(6)
      } else {
        props.chart.xAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(5)
        // if( metric != '# of Conversations' ){
        //   props.chart.xAxis().tickFormat(function(d) { return commasFormatter(d) + ' s'; }).ticks(5);
        //   //props.chart.title(function(d) { return d3.format(",.2r")(d.value) + ' s'; });
        // } else props.chart.xAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(5)
      }
      props.chart.title(function(p) {
        if( metric == "# of Entries") return d3.format(",d")(p.value.count);
        else if( metric == "Total # of Words") return d3.format(",d")(p.value.totalWords);
        else if(metric == "Average # of Words") return d3.format(",.2f")(p.value.avgWords);
        // else if(metric == "Total Vocabulary") return d3.format(",d")(p.value.totalVocabulary);
        // else if(metric == "Average Vocabulary") return d3.format(",.2f")(p.value.avgVocabulary);
        else if(metric == "# of Assignments") return d3.format(",d")(p.value.id_count);
        else if(metric == "# of Students") return d3.format(",d")(p.value.student_count);
      })
      props.chart.colors(function() {
        if( metric == "# of Entries") return [ '#065FE5'];
        else if( metric == "Total # of Words") return ['#2B4E7B'];
        else if(metric == "Average # of Words") return['#2B4E7B'];
        // else if(metric == "Total Vocabulary") return ['#BB3232'];
        // else if(metric == "Average Vocabulary") return ['#BB3232'];
        else if(metric == "# of Assignments") return ['#97D318'];
        else if(metric == "# of Students") return ['#FFA826'];
      })

      props.chart.redraw();
    }
  }

  const resetChart = (reset) => {
    if(props.title == "Student Grades"){
      if(props.chart) {
        props.chart.filterAll();
        //dc.redrawAll();
      }
    }
  }

  updateChart(props.metric);
  console.log("reset in chartemplate "+props.reset)
  if(props.reset) resetChart(props.reset)

  return (
    <select {...style} ref={selection}
      onChange={ (e) => {
        metric =  e.target.value;
        updateChart(metric)
      }}
      >
      {listOptions}
    </select>
  )
}

const ResetButton = props => {
  const style = css({
    fontSize: "9px",
    marginRight: rhythm(-0.02),
    marginTop: rhythm(0.3),
    //padding: rhythm(0.2),
    //paddingLeft: rhythm(0.2),
    display: "inline",
    cursor:'pointer',
    float:'right',
    '&:hover':{
        background: "#ddd",
    }
  });
  return (
    <span  {...style} onClick={() => {
        props.chart.filterAll();
        dc.redrawAll();
      }}
    >
      Reset
    </span>
  );
};
export const ChartTemplate = props => {
    /*
    We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
    but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
    To solve this, we hold a state key and increment it after the effect ran.
    By passing the key to the parent div, we get a rerender once the chart is defined.
    */
  const context = React.useContext(CXContext);
  const [chart,updateChart] = React.useState(null);
  const ndx = context.ndx;
  //const calc = metric//context.calc;
  //console.log(props.title+" metric inside chart "+metric)

  const div = React.useRef(null);
  const n = 1;

  React.useEffect(() => {
    const newChart = props.chartFunction(div.current, ndx); // chartfunction takes the ref and does something with it

    newChart.render();
    updateChart(newChart);
  },[1]); {/*Run this exactly once */}

  const chartStyles  = css({
    width:'100%',
    height:'auto',
    boxSizing:'border-box',
    //marginRight: rhythm(2),
    paddingTop: rhythm(0),
    paddingRight: rhythm(.01),
    paddingBottom: rhythm(.3),
    paddingLeft: rhythm(1),
    '& label':{
      textTransform:'capitalize',
      fontSize: '17px'
      //textDecoration:'underline',
    }

    //{!props.noreset ? <ResetButton chart={chart} /> : ''}

  })
  return (
    <div
      ref={div}
      {...chartStyles}
    >

      <div className={props.showMetricsSelector ? '' : "title-bar--no-show"} >
        {!props.noreset ? <ResetButton chart={chart} /> : ''}
        <label>{props.title}</label>
        <Options chart={chart} reset={props.reset} chartType={props.type} metric={props.metric} showMetricsSelector={props.showMetricsSelector}
          studentGradesMetric={props.studentGradesMetric} title={props.title}/>

      </div>
    </div>
  );
};
